import { defineCapability } from 'nest/capabilities';
export const REFETCH_CREDIT_BALANCE_CAP = defineCapability({
  name: 'REFETCH_CREDIT_BALANCE_CAP',
  args: {}
});